import { computed } from 'vue'
import {
  useAccountAccessRestriction,
  useAccountStatusQuery,
  useKycActionState,
} from '@modules/account'

/** Spec 1.7.5 copy for an investor whose KYC isn't approved yet. */
export const BUY_KYC_REQUIRED_COPY = 'Please complete KYC verification to buy on the Marketplace.'

// Buy on the secondary market needs approved KYC (spec 1.7.5). Browsing stays
// open to everyone. Read from the app-shell-primed account-status cache — the
// same `accountState` the nav chip and wallet use, so the surfaces agree.
// `isKnown` stays false until the status loads, so the prompt never flashes
// for a verified investor.
export function useBuyerKycGate() {
  const accountStatusQuery = useAccountStatusQuery()
  const { kycActionState } = useKycActionState()
  const { isRestricted } = useAccountAccessRestriction()

  const isKnown = computed(() => Boolean(accountStatusQuery.data.value))
  const isKycApproved = computed(() => kycActionState.value === 'verified' && !isRestricted.value)
  /** Show the KYC prompt (and disable Buy) — only once the status is known. */
  const needsKyc = computed(() => isKnown.value && !isKycApproved.value)

  return { isKnown, isKycApproved, needsKyc }
}
